import { State } from '@app/common/enums/state.enum';


export interface Foundation {
  readonly id: number;
  name?: string;
  state?: State;
  color?: string;
  websiteUrl?: string;
  applicationUrl?: string;
}
